import { render, staticRenderFns } from "./RetentionSwitchHeader.vue?vue&type=template&id=6a2c4edb&"
import script from "./RetentionSwitchHeader.vue?vue&type=script&lang=js&"
export * from "./RetentionSwitchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports